import { colorPalette } from '../../colorPalette';
export const useStyles = () => ({
    balance: {
        display: 'flex',
        borderRadius: '30px',
        backgroundColor: colorPalette.red100,
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: '4px',
    },
    clubR: {
        paddingTop: '10px',
        paddingBottom: '5px',
        paddingLeft: '8px',
    },
    amountBalance: {
        color: colorPalette.red800,
        paddingRight: '13px',
        fontSize: '14px',
        fontWeight: 700,
    },
    divider: {
        height: '16px',
        marginTop: '10px'
    }
});
